/* EdgePro tier strip: live active-tier highlight + line total, driven by
   Dawn's quantity input. Also feeds the sticky buy bar total when present. */
(function () {
  function money(n) {
    return '$' + n.toLocaleString('en-AU');
  }

  function init(strip) {
    var sectionId = strip.getAttribute('data-section-id');
    var qtyInput = document.getElementById('Quantity-' + sectionId);
    var tiers = strip.getAttribute('data-tiers').split(',').map(function (pair) {
      var p = pair.split(':');
      return { min: parseInt(p[0], 10), price: parseFloat(p[1]) };
    });
    var moq = parseInt(strip.getAttribute('data-moq'), 10) || 1;
    var chips = strip.querySelectorAll('.ep-ts__chip');
    var totalEl = strip.querySelector('[data-ep-ts-total]');
    var stickyTotal = document.querySelector('[data-ep-sticky-total="' + sectionId + '"]');

    function activeTier(qty) {
      var t = tiers[0];
      for (var i = 0; i < tiers.length; i++) {
        if (qty >= tiers[i].min) t = tiers[i];
      }
      return t;
    }

    function update() {
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : moq;
      if (!qty || qty < 1) qty = moq;
      var tier = activeTier(qty);
      chips.forEach(function (chip) {
        chip.classList.toggle(
          'ep-ts__chip--active',
          parseInt(chip.getAttribute('data-min'), 10) === tier.min
        );
      });
      var total = qty * tier.price;
      var totalText = qty + ' × ' + money(tier.price) + ' = ' + money(total);
      if (totalEl) {
        totalEl.textContent = totalText + ' ';
        var gst = document.createElement('span');
        gst.className = 'ep-ts__total-gst';
        gst.textContent = 'ex GST';
        totalEl.appendChild(gst);
      }
      if (stickyTotal) {
        stickyTotal.textContent = totalText + ' ex GST';
      }
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', update);
      qtyInput.addEventListener('change', update);
    }

    /* Chips set the quantity to their tier minimum. Dispatching input +
       change lets Dawn's quantity handlers, the MOQ guard, and the sticky
       bar all react through their normal paths. */
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (!qtyInput) return;
        qtyInput.value = chip.getAttribute('data-min');
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    update();
  }

  document.querySelectorAll('[data-ep-tier-strip]').forEach(init);
})();
